import { FormControl, TextField } from "@material-ui/core";
import React from "react";
import clsx from "clsx";

import { useFunctionStyles } from "./styles";

interface FunctionTextInputProps
  extends React.ComponentPropsWithoutRef<typeof TextField> {
  label: string;
  name: string;
  value: string;
  onChangeText: (value: string) => void;
}

export const FunctionTextInput: React.FC<FunctionTextInputProps> = (props) => {
  const classes = useFunctionStyles();

  const { label, name, value, onChangeText, ...rest } = props;

  return (
    <FormControl
      component="fieldset"
      className={clsx("my-5", "w-full", classes.formControl)}
    >
      <TextField
        fullWidth
        autoComplete="off"
        InputLabelProps={{ shrink: true }}
        variant="outlined"
        label={label}
        name={name}
        onChange={(e) => {
          onChangeText(e.target.value);
        }}
        value={value}
        {...rest}
      />
    </FormControl>
  );
};
